import { Send } from "lucide-react";

import { useShowRowContext } from "@/components/shows";

export function ShowRowShareButton() {
  const { handleShare } = useShowRowContext();

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        handleShare();
      }}
      className="p-1.5 rounded-sm"
      aria-label="Share show"
    >
      <Send className="w-6 h-6 text-primary" />
    </button>
  );
}
